import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const VIEWBOX_CENTER = 1024;
const DEFAULT_ICON_SCALE = 1.28;

const GeneratedSvgIcon = React.forwardRef(function GeneratedSvgIcon(
  { svgContent, children, scale = DEFAULT_ICON_SCALE, ...props },
  ref
) {
  const transform = `translate(${VIEWBOX_CENTER} ${VIEWBOX_CENTER}) scale(${scale}) translate(-${VIEWBOX_CENTER} -${VIEWBOX_CENTER})`;
  return (
    <SvgIcon {...props} ref={ref} viewBox="0 0 2048 2048">
      {svgContent ? (
        <g transform={transform} dangerouslySetInnerHTML={{ __html: svgContent }} />
      ) : (
        <g transform={transform}>{children}</g>
      )}
    </SvgIcon>
  );
});

export default GeneratedSvgIcon;
